<template>
    <div>
            <b-form>
                <div class="animated fadeIn">
                    <b-row>
                        <b-col md="12">
                            <b-form>
                            <b-form-group
                            description=""
                            label="Tipo de evento"
                            label-for="eventType"
                            :label-cols="3"
                            :horizontal="true">
                            <b-form-select id="event"
                                v-model="selectedItem.typeId"
                                :plain="true"
                                :options="eventTypeDDL"
                                :value="[null,'c']"
                                :class="eventTypeClass"
                                >
                            </b-form-select>
                            </b-form-group>          
                            </b-form>
                        </b-col>
                    </b-row>

                    <b-row>
                        <b-col md="12">
                            <b-form>
                            <b-form-group
                            description=""
                            label="Evento"
                            label-for="event"
                            :label-cols="3"
                            :horizontal="true">
                            <b-form-input id="event" v-model="selectedItem.name" type="text" style="text-transform: uppercase" :class="nameClass" ></b-form-input>
                            </b-form-group>          
                            </b-form>
                        </b-col>
                    </b-row>

                    <b-row>
                        <b-col md="12">
                            <b-form>
                            <b-form-group
                            description=""
                            label="Dia da semana"
                            label-for="weekday"
                            :label-cols="3"
                            :horizontal="true">
                            
                            <!--:checked="[2,3]" -->
                            <b-form-checkbox-group v-model="selectedItem.weekDaysList" :stacked="false" id="weekday" name="weekday" :plain="true" >
                                <b-form-checkbox :plain="true" value="1">Domingo</b-form-checkbox>
                                <b-form-checkbox :plain="true" value="2">Segunda</b-form-checkbox>
                                <b-form-checkbox :plain="true" value="3">Terça</b-form-checkbox>
                                <b-form-checkbox :plain="true" value="4">Quarta</b-form-checkbox>
                                <b-form-checkbox :plain="true" value="5">Quinta</b-form-checkbox>
                                <b-form-checkbox :plain="true" value="6">Sexta</b-form-checkbox>
                                <b-form-checkbox :plain="true" value="7">Sábado</b-form-checkbox>
                            </b-form-checkbox-group>
                                
                            </b-form-group>          
                            </b-form>
                        </b-col>
                    </b-row>


                    <b-row>
                        <b-col md="12">
                            <b-form>
                                <b-form-group
                                description=""
                                label="Lista de presença?"
                                label-for="attendanceList"
                                :label-cols="3"
                                :horizontal="true">
                                <b-row>
                                    <b-col md="2"><c-switch v-model="selectedItem.attendanceList" color="primary" variant="pill" :false-value="false" :true-value="true" label v-bind="switchLabelIcon"  /></b-col>
                                    <b-col md="4">Check-in no evento?</b-col>
                                    <b-col md="2"> <c-switch v-model="selectedItem.checkIn" color="primary" variant="pill" :false-value="false" :true-value="true" label v-bind="switchLabelIcon"  /> </b-col>
                                </b-row>
                            </b-form-group>          
                            </b-form>
                        </b-col>
                    </b-row>

                    <b-row>
                        <b-col md="12">
                            <b-form>
                            <b-form-group
                            description=""
                            label="Observação"
                            label-for="notes"
                            :label-cols="3"
                            :horizontal="true">
                            <b-form-textarea
                                    id="notes"
                                    v-model="selectedItem.notes"
                                    placeholder=""
                                    rows="3"
                            ></b-form-textarea>
                            </b-form-group>          
                            </b-form>
                        </b-col>
                    </b-row>

                    <hr>

                    <b-row>
                        <b-col md="12">
                            <b-form>
                            <b-form-group
                            description=""
                            label="Taxa de registro"
                            label-for="registrationFee"
                            :label-cols="3"
                            :horizontal="true">
                            <b-row>
                                <b-col md="2">
                                    <b-form-input id="registrationFee" v-model="selectedItem.registrationFee" type="number" ></b-form-input>
                                </b-col>
                                <b-col md="2" style="padding-top: 5px;">
                                    Mensalidade
                                </b-col>
                                <b-col md="2">
                                    <b-form-input id="monthlyValue" v-model="selectedItem.monthlyValue" type="number" ></b-form-input>
                                </b-col>
                            </b-row>
                            
                            </b-form-group>          
                            </b-form>
                        </b-col>
                    </b-row>

                    <hr>

                    <b-row>
                        <b-col md="12">
                            <b-form>
                            <b-form-group
                            description=""
                            label="Grupo da Associação"
                            label-for="franchiseGroup"
                            :label-cols="3"
                            :horizontal="true">
                            <b-row>
                                <b-col md=5>
                                    <b-form-select id="franchiseGroup"
                                        v-model="selectedItem.franchiseGroupId"
                                        :plain="true"
                                        :options="selectFranchiseGroupDDL"
                                        :value="[null,'c']">
                                    </b-form-select>
                                </b-col>
                            </b-row>
                            
                            </b-form-group>          
                            </b-form>
                        </b-col>
                    </b-row>

                    <b-row>
                        <b-col md="12">
                            <b-form>
                            <b-form-group
                            description=""
                            label="Status"
                            label-for="eventStatus"
                            :label-cols="3"
                            :horizontal="true">
                            <b-row>
                                <b-col md=5>
                                    <b-form-select id="eventStatus"
                                        v-model="selectedItem.statusId"
                                        :plain="true"
                                        :options="eventStatusDDL"
                                        :value="[null,'c']">
                                    </b-form-select>                                    
                                </b-col>
                            </b-row>

                            </b-form-group>          
                            </b-form>
                        </b-col>
                    </b-row>

                    

                </div>
            </b-form>

            <div slot="footer" class="text-right">
                    <!--
                    <b-button variant="stack-overflow" class="mr-1 btn-brand" @click="enableDisable()" v-show="this.selectedItem.id && this.selectedItem.st=='I'"><i class="fa fa-times"></i><span>Habilitar</span></b-button>
                    <b-button variant="html5" class="mr-1 btn-brand" @click="enableDisable()" v-show="this.selectedItem.id && this.selectedItem.st=='A'"><i class="fa fa-times"></i><span>Desabilitar</span></b-button>
                    -->
                    <b-button variant="github" class="mr-1 btn-brand" @click="save()"><i class="fa fa-check"></i><span>Salvar Evento</span></b-button>
                    
            </div>
    </div>  

</template>


<script>
import Vue from 'vue'
import axios from "axios";
import MaskedInput from 'vue-text-mask'
import { Switch as cSwitch } from '@coreui/vue'
  
/* Toast */
import VueNotifications from 'vue-notifications'
  import miniToastr from 'mini-toastr'// https://github.com/se-panfilov/mini-toastr
  //import { table } from 'console'
  
  const toastTypes = {
    success: 'success',
    error: 'error',
    info: 'info',
    warn: 'warn'
  }
  
  miniToastr.init({types: toastTypes})
  
  function toast ({title, message, type, timeout, cb}) {
    return miniToastr[type](message, title, timeout, cb)
  }
  
  const options = {
    success: toast,
    error: toast,
    info: toast,
    warn: toast
  }
  VueNotifications.setPluginOptions(options)
  
  Vue.use(VueNotifications, options)
  /* Toast - End */

export default {
    name: 'eventComponent',
    props: {
       item: {},
       companyId: 0,
       eventStatusDDL: {}
    },
    components: {
      MaskedInput,
      cSwitch
    },
    data: () => {
        return {         

            franchiseGroupDDL: [],
            eventTypeDDL: [], 

            eventTypeClass: '',
            nameClass: '',
                        
            switchLabelIcon: {
                dataOn: '\u2713',
                dataOff: '\u2715'
            }
        }
    },
    computed: {
        selectedItem() {
            return this.item
        },

        selectFranchiseGroupDDL: function() {
          var list = [...this.franchiseGroupDDL]
          list = list.sort((a,b) => (a.text > b.text) ? 1 : -1)
          list.unshift({ value: '0' , text: '-' })
          return list
      }
    },
    methods: {
        save() {
            let errorFound = false

            this.nameClass = (this.selectedItem.name.length <= 2) ? 'is-invalid' : ''
            this.weekdayClass = (!this.selectedItem.weekdayId || this.selectedItem.weekdayId <= 0) ? 'is-invalid' : ''
            this.meetingTimeClass = (!this.selectedItem.meetingTime || this.selectedItem.meetingTime <= 0) ? 'is-invalid' : ''

            if(!this.selectedItem.typeId || this.selectedItem.typeId <= 0) {
                this.eventTypeClass = "is-invalid"
                errorFound = true
            }
            else {
                this.eventTypeClass = ""
            }

            if(this.selectedItem.name.length <= 2) {
                this.nameClass = "is-invalid"
                errorFound = true
            }
            else {
                this.nameClass = ""
            }
            
            if(!errorFound) {                
                this.saveItem(this.selectedItem);
            }
        },
        
        async saveItem(currentItem) {

            var s = this;
            var postData = {...currentItem};

            postData["companyId"] = this.companyId
            postData["uid"] = this.$store.state.currentUser.id,
            postData["sid"] = this.$store.state.currentUser.sid

            console.log(postData)

            await axios.post(
                this.$store.state.ws_url + "/event",
                postData
            ).then(function() {
                s.$emit('resp',{ code: 1, message: 'Evento salvo com sucesso' })
            }
            ).catch(function (error) {
                console.log(error);
                toast ({
                    type: VueNotifications.types.error,
                    title: 'Evento',
                    message: error.response && error.response.data && error.response.data.message ? error.response.data.message : 'Sem permissão de acesso.',
                    timeout: 5000
                })        
            });

        },

        async getEventType() {
          var s = this;
          var currentUser = this.$store.state.currentUser;
          this.isBusy = true;

          await axios.get(
              this.$store.state.ws_url + "/event/type/ddl?companyId=" + this.companyId + "&uid=" + currentUser.id + "&sid=" + currentUser.sid
          ).then(function (resp) {
              s.eventTypeDDL = resp.data.obj;
          }
          ).catch(function (error) {
              console.log(error.message);            
          });

          this.isBusy = false;
    
        },
        
        async getFranchiseGroup() {
          var s = this;
          var currentUser = this.$store.state.currentUser;
          this.isBusy = true;

          await axios.get(
              this.$store.state.ws_url + "/franchise/group/ddl?companyId=" + this.companyId + "&isGroup=1&uid=" + currentUser.id + "&sid=" + currentUser.sid
          ).then(function (resp) {
              s.franchiseGroupDDL = resp.data.obj;
          }
          ).catch(function (error) {
              console.log(error.message);            
          });

          this.isBusy = false;
    
        },
    },
    mounted: function() {
        this.getEventType()
        this.getFranchiseGroup()
    }
}
</script>